const COPY_RESET_MS = 2000;

const showCopySuccess = (root, button) => {
  const label = button.querySelector('.portal-clinico-prescricao__btn-label');

  if (!label) {
    return;
  }

  const defaultLabel = label.dataset.defaultLabel || label.textContent.trim();
  const successLabel = root.dataset.copySuccessLabel?.trim() || 'Copiado';

  if (button._copyResetTimeout) {
    clearTimeout(button._copyResetTimeout);
  }

  label.textContent = successLabel;
  button.setAttribute('aria-label', successLabel);
  button.classList.add('portal-clinico-prescricao__btn--copied');

  button._copyResetTimeout = setTimeout(() => {
    label.textContent = defaultLabel;
    button.setAttribute('aria-label', defaultLabel);
    button.classList.remove('portal-clinico-prescricao__btn--copied');
    button._copyResetTimeout = null;
  }, COPY_RESET_MS);
};

const initPortalClinicoPrescricao = (root) => {
  if (!root || root.dataset.prescricaoInit === 'true') {
    return;
  }

  root.dataset.prescricaoInit = 'true';

  root.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-target]');

    if (!button || !root.contains(button)) {
      return;
    }

    const target = button.dataset.copyTarget;
    const text =
      target === 'code' ? root.dataset.referralCode?.trim() : root.dataset.referralLink?.trim();

    if (!text) {
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      showCopySuccess(root, button);
    } catch {
      /* clipboard unavailable */
    }
  });
};

document.querySelectorAll('.portal-clinico-prescricao').forEach(initPortalClinicoPrescricao);
